import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-shell-v2',
  templateUrl: './app-shell-v2.component.html',
  styleUrls: ['./app-shell-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppShellV2Component {
  @Input() loginURL: string | null = null;

  readonly currentYear = new Date().getFullYear();
}
